export default __webpack_public_path__ + "350109e0f7b93c218679bf1e0c0ee9aa.png";